import Image, { ImageProps } from 'next/image';
import { SelectedMedia } from '@/lib/model';
import { COMMON_RESPONSIVE_IMAGE_SIZES } from '@/utils/image/reponsiveSizes';
import { toBase64, mediaShimmer } from '../../media/mediaShimmer';
import { cn } from '@/lib/utils';
import { getOptimizedImageFromCoverImage } from '@/common/utils';
import { ImagePlaceholder } from '@/app/components/media/ImagePlaceholder';
import { getImageBoxAspectRatio } from '@/common/media';

type Props = Partial<ImageProps> & {
  item: SelectedMedia;
  ignoreAspectRatio?: boolean;
  calculateAspectRatio?: boolean;
  verticalClassName?: string;
  horizontalClassName?: string;
  imageClassName?: string;
};
export const ImageBox = ({
  item,
  className,
  width,
  height,
  ignoreAspectRatio,
  calculateAspectRatio,
  verticalClassName = '',
  horizontalClassName = '',
  imageClassName = '',
  style,
  ...props
}: Props) => {
  const { aspectRatio, isVertical } = getImageBoxAspectRatio(
    item,
    undefined,
    calculateAspectRatio,
    ignoreAspectRatio,
    width as number,
    height as number,
  );

  if (
    !(
      item?.media?.imageUrl?.startsWith('https://') ||
      item?.media?.url?.startsWith('https://')
    )
  ) {
    return (
      <ImagePlaceholder
        width={width}
        height={height}
        className={className}
        style={{ ...style, aspectRatio }}
        {...props}
      />
    );
  }
  return (
    <>
      <Image
        alt={item?.media.caption ?? item?.media.url ?? ''}
        quality={80}
        loading="lazy"
        sizes={COMMON_RESPONSIVE_IMAGE_SIZES}
        {...props}
        style={{ ...style, ...(aspectRatio && { aspectRatio }) }}
        className={cn('object-cover rounded', className, imageClassName, {
          [verticalClassName]: isVertical,
          [horizontalClassName]: !isVertical,
        })}
        src={
          getOptimizedImageFromCoverImage(
            item,
            width as number,
            height as number,
          ) as string
        }
        width={width}
        height={height}
        placeholder={`data:image/svg+xml;base64,${toBase64(mediaShimmer({ width, height }))}`}
      />
    </>
  );
};
